export default __webpack_public_path__ + "static/media/IMG6.de504de1.png";